// @ts-ignore
import notificationSound from 'assets/sounds/notification.mp3';

/**
 * Add 0 as prefix if the provided number is lower then 10
 * to match 00 time format
 *
 * @param {number} count
 * @return {*}  {string}
 */
export const addZeroPrefix = (count: number): string => {
  if (count < 10) {
    return `0${count}`;
  }

  return String(count);
};

/**
 * Blinks page title switching between old and new title
 *
 * @param {string} newTitle
 * @param {number} [blinkCount=5]
 */
export const blinkPageTitle = (newTitle: string, blinkCount = 5): void => {
  const originalTitle = 'Vet4all';
  let count = 0;

  if (blinkCount <= 0) {
    return;
  }

  const intervalId = setInterval(() => {
    document.title =
      document.title === originalTitle ? newTitle : originalTitle;

    if (count >= blinkCount) {
      clearInterval(intervalId);
      document.title = originalTitle;
    }
    count++;
  }, 1000);
};

/**
 * Play notification sound
 *
 */
export const playNotificationSound = (): void => {
  new Audio(notificationSound).play();
};

export const ChangeSrollCss = {
  '&::-webkit-scrollbar': {
    width: '7px',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '10px',

    '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)',
  },
};

export const stringLimiter = (
  string: string | number | boolean,
  maxLength: number
): string => {
  if (string && typeof string === 'string') {
    if (string.length <= maxLength) {
      return string;
    }
    return `${string.substring(0, maxLength)}...`;
  }
  return '';
};
/**
 * Convert a bse64 string into a file object
 *
 * @param {string} url
 * @param {string} filename
 * @param {string} mimeType
 * @return {*}  {Promise<File>}
 */
export const convertBase64ToFile = async (
  url: string,
  filename: string,
  mimeType: string
): Promise<File> => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, { type: mimeType });
};
